import { Chip, styled } from "@mui/material";

export const StatusChip = styled(Chip)`
  color: ${({ theme }) => theme.palette.neutral?.main};
  margin-left: 20px;
  text-transform: capitalize;
`;
